export enum DialogLocationLabels {
  noLocationsFound = 'No se encontraron ubicaciones, verifique su información',
  noLocationsFoundByShipper = 'No se encontraron ubicaciones de este embarcador, verifique su información'
}

export enum DialogLocationTags {
  address = 'Dirección',
  dialogResume = 'Selecciona la ubicación',
  identifier = 'Identificador',
  identifierIs = 'El identificador es ',
  manual = 'Manual',
  name = 'Nombre',
  nameIs = 'El nombre es ',
  postalCode = 'Código postal',
  postalCodeAbbreviation = 'C.P.',
  postalCodeIs = 'El código postal es ',
  required = 'requerid',
  state = 'Estado',
  suffixO = 'o'
}
